import React from "react";
import FormLayout from '../FormLayout';
import TextField from './TextField';
import { Field } from 'redux-form';
import Utils from '../../services/Utils';

/** Class representing a PDF layout custom text field. */
class PasswordField extends TextField {

    constructor(properties) {
        super({
            ...(PasswordField.getDefaultOptions()),
            ...properties,
        });

        this.type = FormLayout.PASSWORD;
    }

    /**
     * Return this field preview input
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {Bool} inPreview
     *                 - {String} lang
     *                 - {Object} setting
     *                 - {Any} value
     *                 - {Object} resources
     */
    getInput(props) {
        const placeholderText = Utils.localized_or_fallback(
            this.placeholder, props?.lang, ''
        );

        return (
            <Field
                component="input"
                type="password"
                name={this.reduxFieldName(props)}
                required={this.htmlRequired(props)}
                className="form-control"
                autoComplete="new-password"
                placeholder={placeholderText || undefined}
            />
        );
    }

    /**
     * Render a value
     *
     * @param {Any} value
     * @param {Object} context: an object with the following keys:
     *                   - lang (mandatory)
     *                   - t (mandatory)
     *                   - format (optional)
     *
     * @return {String}
     */
    renderValue(_value, _context) {
        return <span dangerouslySetInnerHTML={{__html: '&bull;&bull;&bull;&bull;&bull;&bull;' }} />
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'key';
    }
}

export default PasswordField;
